var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded && _vm.showContato)?_c('aside',{attrs:{"id":"contatoWhatsapp"}},[_c('a',{attrs:{"href":_vm.$configuracoes.whatsappLink,"target":"_blank"}},[_c('FontAwesomeIcon',{attrs:{"icon":_vm.icons.faWhatsapp}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }